import FreeTrialWelcomeModal from './FreeTrialWelcomeModal';

export default FreeTrialWelcomeModal;
